import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spinner, Alert, Form, Button, Card, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import apiService from "../../API/ApiService.js";


const UserJoystickSettings = () => {
  const [raspberryDevices, setRaspberryDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [userId, setUserId] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  
  const username = localStorage.getItem('username');


  useEffect(() => {
    const fetchUserId = async () => {
      if (username) {
        try {
          const response = await apiService.get('/getUserIdByEmail', {
            params: { email: username },
          });
          console.log('sett response',response)
          setUserId(response.data.userId);
        } catch (error) {
          console.error('Error fetching user ID:', error);
          setError('Failed to fetch user ID');
        } finally {
          setLoading(false);
        }
      } else {
        setError('Username not found in localStorage');
        setLoading(false);
      }
    };
  
    fetchUserId();
  }, [username]);
  

  useEffect(() => {
    if (userId) {
      const fetchDevices = async () => {
        try {
          const response = await apiService.get(`/raspberry/${userId}`);
          setRaspberryDevices(response.data);
        } catch (err) {
          console.error('Error fetching Raspberry Pi devices:', err);
          setError('Unable to load Raspberry Pi devices.');
        } finally {
          setLoading(false);
        }
      };
  
      fetchDevices();
    }
  }, [userId]);
  

  const validateField = (name, value) => {
    if ((name === 'color_switch_speed' || name === 'players_led_switch_speed') && parseInt(value) === 0) {
      return "Value cannot be 0";
    }
    return null;
  };

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    
    // Validation
    const error = validateField(name, value);
    if (error) {
      setFormErrors(prev => ({
        ...prev,
        [`${id}_${name}`]: error
      }));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[`${id}_${name}`];
        return newErrors;
      });
    }

    setRaspberryDevices((prevDevices) =>
      prevDevices.map((device) =>
        device.id === id ? { ...device, [name]: value } : device
      )
    );
  };

  const handleUpdate = async (e, id) => {
    e.preventDefault();
    
    // Vérification finale avant soumission
    const device = raspberryDevices.find((device) => device.id === id);
    const errors = {};
    
    if (parseInt(device.color_switch_speed) === 0) {
      errors[`${id}_color_switch_speed`] = "Color Switch Speed cannot be 0";
    }
    
    if (parseInt(device.players_led_switch_speed) === 0) {
      errors[`${id}_players_led_switch_speed`] = "Players LED Switch Speed cannot be 0";
    }
    
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setError('❌ Please fix the validation errors before submitting.');
      return;
    }

    try {
      await apiService.put(`/raspberry/${id}`, {
        minJoystick: device.minJoystick,
        maxJoystick: device.maxJoystick,
        color_switch_speed: device.color_switch_speed,
        players_led_switch_speed: device.players_led_switch_speed,
      });
      setMessage('✅ Tester settings updated successfully!');
      setError('');
    } catch (err) {
      console.error('Error updating Raspberry Pi settings:', err);
      setMessage('');
      setError('❌ Update failed.');
    }
    
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <Container className="py-5">
      {message && <Alert variant="success" className="text-center">{message}</Alert>}
      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      <h3 className="text-center mb-4 text-primary font-weight-bold display-4">
        <i className="bi bi-device-desktop"></i> Tester Devices Settings
      </h3>

      <Row className="justify-content-center">
        {raspberryDevices.map((device) => (
          <Col xl={6} lg={8} md={10} sm={12} key={device.id} className="mb-4">
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <Card.Title className="text-center mb-4 fs-3">{device.id}</Card.Title>

                <Form onSubmit={(e) => handleUpdate(e, device.id)} className="mx-auto" style={{ maxWidth: '500px' }}>
                  <Form.Group className="mb-3">
                    <Form.Label>🎮 Min Joystick</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="minJoystick"
                      value={device.minJoystick}
                      onChange={(e) => handleChange(e, device.id)}
                      className="text-center"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>🚀 Max Joystick</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="maxJoystick"
                      value={device.maxJoystick}
                      onChange={(e) => handleChange(e, device.id)}
                      className="text-center"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>🎨⚡ Color Switch Speed (ms)</Form.Label>
                    <Form.Control
                      type="number"
                      step="1"
                      min="1"
                      name="color_switch_speed"
                      value={device.color_switch_speed || 1000}
                      onChange={(e) => handleChange(e, device.id)}
                      className="text-center"
                      isInvalid={!!formErrors[`${device.id}_color_switch_speed`]}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors[`${device.id}_color_switch_speed`]}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>💡⚡ Players LED Switch Speed (ms)</Form.Label>
                    <Form.Control
                      type="number"
                      step="1"
                      min="1"
                      name="players_led_switch_speed"
                      value={device.players_led_switch_speed || 1000}
                      onChange={(e) => handleChange(e, device.id)}
                      className="text-center"
                      isInvalid={!!formErrors[`${device.id}_players_led_switch_speed`]}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors[`${device.id}_players_led_switch_speed`]}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-grid gap-2">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      size="lg"
                      disabled={Object.keys(formErrors).some(key => key.startsWith(`${device.id}_`))}
                    >
                      💾 Save Changes
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default UserJoystickSettings;